import { Link } from "react-router-dom";
import ContentPage from "../components/ContentPage";

const TermsOfService = () => (
  <ContentPage title="Terms of Service">
    <h1 className="content-page__title">Terms of Service</h1>
    <p className="content-page__subtitle">
      The rules that keep PeerPoetry fair, safe, and welcoming.
    </p>
    <div className="peer-home-page-card p-5 sm:p-8 md:p-10 space-y-6 min-w-0 box-border">
      <p className="text-[#333333] text-base">
        <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
      </p>
      <p className="text-[#333333] text-base">
        Welcome to <strong>PeerPoetry</strong>. By accessing or using our platform, you
        agree to be bound by these Terms of Service. Please read them carefully.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">1. Acceptance of Terms</h2>
      <p className="text-[#333333] text-base">
        By creating an account, accessing, or using PeerPoetry, you agree to comply
        with and be bound by these Terms of Service and our Privacy Policy. If
        you do not agree with these terms, please do not use our service.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">2. Account Registration</h2>
      <ul className="list-disc list-inside text-[#333333] space-y-1">
        <li>
          You must be at least 13 years old to create an account and use PeerPoetry.
        </li>
        <li>
          You are responsible for maintaining the confidentiality of your
          account credentials.
        </li>
        <li>
          You must provide accurate and complete information when registering.
        </li>
        <li>
          You are responsible for all activities that occur under your account.
        </li>
        <li>
          You must verify your email address before your account is fully
          activated.
        </li>
      </ul>

      <h2 className="text-xl font-bold mt-6 mb-2">3. User Responsibilities</h2>
      <p className="text-[#333333] text-base mb-2">
        As a user of PeerPoetry, you agree to:
      </p>
      <ul className="list-disc list-inside text-[#333333] space-y-1">
        <li>Use the platform in a lawful manner</li>
        <li>
          Respect the rights and dignity of other users and their content
        </li>
        <li>Not engage in harassment, bullying, or hate speech</li>
        <li>Not impersonate others or provide false information</li>
        <li>Not spam, abuse, or misuse the reporting system</li>
        <li>
          Report inappropriate content or behavior through the proper channels
        </li>
      </ul>

      <h2 className="text-xl font-bold mt-6 mb-2">
        4. Content Ownership and Licensing
      </h2>
      <p className="text-[#333333] text-base mb-2">
        You retain ownership of the poems, comments, and other content you post
        on PeerPoetry. By posting content, you grant PeerPoetry:
      </p>
      <ul className="list-disc list-inside text-[#333333] space-y-1">
        <li>
          A worldwide, non-exclusive, royalty-free license to use, display, and
          distribute your content on the platform
        </li>
        <li>
          The right to moderate, edit, or remove content that violates these
          terms
        </li>
        <li>
          The right to display your content to other users as part of the
          platform's functionality
        </li>
      </ul>
      <p className="text-[#333333] text-base mt-2">
        You represent and warrant that you own or have the right to post all
        content you submit, and that your content does not infringe upon the
        rights of others.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">5. Prohibited Content</h2>
      <p className="text-[#333333] text-base mb-2">
        You may not post content that:
      </p>
      <ul className="list-disc list-inside text-[#333333] space-y-1">
        <li>Is illegal, harmful, or violates any laws</li>
        <li>
          Contains hate speech, discrimination, or promotes violence against
          individuals or groups
        </li>
        <li>Is defamatory, harassing, or threatening</li>
        <li>Infringes on intellectual property rights of others</li>
        <li>Contains explicit sexual content or pornography</li>
        <li>Is spam, advertisements, or self-promotion outside appropriate areas</li>
        <li>
          Contains malware, viruses, or other harmful code
        </li>
        <li>
          Violates the privacy or confidentiality of others
        </li>
      </ul>

      <h2 className="text-xl font-bold mt-6 mb-2">
        6. Content Moderation and Removal
      </h2>
      <p className="text-[#333333] text-base">
        PeerPoetry reserves the right to review, moderate, edit, or remove any content
        that violates these Terms of Service. We may suspend or terminate
        accounts that repeatedly violate these terms. Moderators and administrators
        have the authority to enforce these terms and make decisions about content
        removal.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">7. Account Termination</h2>
      <p className="text-[#333333] text-base mb-2">
        You may delete your account at any time through your profile settings.
        Upon account deletion:
      </p>
      <ul className="list-disc list-inside text-[#333333] space-y-1">
        <li>Your account will be permanently deleted</li>
        <li>Your poems and comments will be removed from the platform</li>
        <li>
          Your profile information will be deleted, though some data may remain
          in backups for a limited time
        </li>
      </ul>
      <p className="text-[#333333] text-base mt-2">
        PeerPoetry reserves the right to suspend or terminate accounts that violate
        these terms, without notice, at our sole discretion.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">
        8. Intellectual Property
      </h2>
      <p className="text-[#333333] text-base mb-2">
        The PeerPoetry platform, including its design, features, logos, and branding,
        is protected by intellectual property laws. You may not:
      </p>
      <ul className="list-disc list-inside text-[#333333] space-y-1">
        <li>Copy, reproduce, or create derivative works of the platform</li>
        <li>Reverse engineer or attempt to extract source code</li>
        <li>Use PeerPoetry's branding or trademarks without permission</li>
        <li>Scrape, harvest, or collect data from the platform without authorization</li>
      </ul>

      <h2 className="text-xl font-bold mt-6 mb-2">
        9. Limitation of Liability
      </h2>
      <p className="text-[#333333] text-base">
        PeerPoetry is provided "as is" without warranties of any kind. We do not
        guarantee that the platform will be error-free, uninterrupted, or
        secure. PeerPoetry and its operators shall not be liable for any indirect,
        incidental, special, or consequential damages arising from your use of
        the platform.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">10. Indemnification</h2>
      <p className="text-[#333333] text-base">
        You agree to indemnify and hold harmless PeerPoetry, its operators, and
        affiliates from any claims, damages, losses, or expenses (including
        legal fees) arising from your use of the platform, your content, or your
        violation of these Terms of Service.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">11. Changes to Terms</h2>
      <p className="text-[#333333] text-base">
        We reserve the right to modify these Terms of Service at any time. We
        will notify users of significant changes, but you are responsible for
        reviewing these terms periodically. Continued use of PeerPoetry after changes
        constitutes acceptance of the updated terms.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">12. Governing Law</h2>
      <p className="text-[#333333] text-base">
        These Terms of Service are governed by applicable laws. Any disputes
        will be resolved through appropriate legal channels. For users in the
        European Union, your local consumer protection laws apply.
      </p>

      <h2 className="text-xl font-bold mt-6 mb-2">13. Contact</h2>
      <p className="text-[#333333] text-base">
        For questions about these Terms of Service, please use the{" "}
        <Link to="/feedback" className="text-[#f26522] hover:underline">
          Feedback
        </Link>{" "}
        page or email us at{" "}
        <a
          href="mailto:support@peerpoetry.com"
          className="text-[#f26522] hover:underline"
        >
          support@peerpoetry.com
        </a>
        .
      </p>

      <div className="border-t pt-6 mt-6">
        <p className="text-sm text-[#777777] text-center">
          By using PeerPoetry, you acknowledge that you have read, understood, and
          agree to be bound by these Terms of Service and our{" "}
          <Link to="/privacy" className="peer-home-link hover:underline">
            Privacy Policy
          </Link>
          .
        </p>
      </div>

      <p className="text-xs text-[#777777] mt-8 text-center">
        These terms may be updated from time to time. Last updated:{" "}
        {new Date().toLocaleDateString()}
      </p>
    </div>
  </ContentPage>
);

export default TermsOfService;

